import React from 'react'
import styled, {DefaultTheme} from 'styled-components'
import Box from '../layout/Box'

export interface UnorderedListProps {
  $variant?: keyof DefaultTheme['typography']['lists']
}

const UnorderedList = styled(Box).attrs({as: 'ul'})<
  UnorderedListProps & React.ComponentProps<typeof Box>
>`
  ${({theme, $variant}) =>
    $variant && theme.expandVariants($variant, theme.typography.lists.unordered)}
`

UnorderedList.displayName = 'UnorderedList'

export default UnorderedList
